<template class="fondo">
  <div class="loader" v-if="this.isLoading">
    <img class="rounded mx-auto d-block" src="@/assets/loading.gif" />
  </div>
  <div class="contenedor fondo">
    <div class="d-flex contimg">
      <img src="@/assets/img2.png" class="imagens">
    </div>


  <div class="texto-center" >
      <img src="@/assets/img15.png" class="imagens2 imgMobile"  style="width: 100%">  
    </div>
  <div class="texto-center">
      <span class="texto-rojo textMobile" style="font-size: 50px;">ESTÁS UN PASO MÁS CERCA DE ZARPAR EN CRUCERO:</span>
    </div>

    <div class="texto-center" >
      <img src="@/assets/img10.png" class="imagens2 imgMobile" style="width: 800px">  
    </div>

    <div class="texto-center">
      <span class="texto-bold textMobile" >CUANTO MÁS PUNTOS ACUMULES MÁS OPORTUNIDADES TENDRÁS DE SER UNO DE LOS 2000 CLIENTES AFORTUNADOS.</span>
    </div>

    <div class="texto-center">
      <span class="texto-rojo textMobile" style="font-size: 60px;">PUEDES REVISAR TU POSICIÓN INGRESANDO A: WWW.ENJOY.CL/CRUCEROS</span>
    </div>


    <div class="texto-center">
    <span class="texto-bold textMobile" >TODOS LOS PUNTOS QUE ACUMULES DESDE EL 13 DE OCTUBRE AL 01 DE DICIEMBRE DE 2023 CONTARÁN PARA LA PROMOCIÓN, A PESAR DE QUE TU INSCRIPCIÓN SEA POSTERIOR A ESA FECHA.</span>
  </div>

    <div class="texto-center">
      <p class="texto-white">Revisa las <a href="https://www.enjoy.cl/cruceros/bases.pdf" target="_blank" style="color: white;">bases y condiciones aquí</a>.</p>
  </div>
</div>

<div class="row justify-content-center">
    <div class="col-md-12">
      <img src="@/assets/img3.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>


</template>


<script>
import useValidate from '@vuelidate/core'
import axios from "axios";
import variables from '@/static/endPoint.json'
import { required, email, minLength, numeric, minValue,} from '@vuelidate/validators'

export default {
  name: 'desafio',

  created(){
    window.scrollTo(0,0);
  },
    
}
</script>

<style>


/* Estilos para pantallas más grandes (por ejemplo, PCs) */
@media (min-width: 768px) {
  .contimg {
  display: flex;
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: left;
}


.imagens {
  width: 20%; /* La imagen ocupa el 20% del ancho del div */
  margin-top: 2%; /* Margen superior en dispositivos móviles */
  margin-left: 10%;
}

.contimg2 {
  display: flex;
  width: 100%;
  position: relative;
  margin-top: -10%;

}

.imagens2 {
  width: 100%;
}

.curadradoRojo{
  background-color: #d7332a; /* Fondo rojo */
  padding: 10px;

}
.texto-derecha {
  position: absolute;
  top: 50%;
  right: 5%;
  color: white; /* Texto en blanco */
  transform: translateY(-50%);
  text-align: center;
  font-size: 40px; /* Establece el tamaño de fuente solo para el segundo label */
  padding: 10px;
}

.texto-derecha label {
  font-weight: bold; /* Hace que todos los labels sean negrita */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;
}


.texto-derecha br {
  margin: 0%;
  padding: 0%;

}
.masFont {
  font-size: 150px; /* Establece el tamaño de fuente solo para el segundo label */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;

}

.texto-center {
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 1%;
}

.texto-white {
  color: #FFFFFF;
  font-family: 'Gotham', sans-serif;
  font-weight: lighter; /* Texto ligero */
  font-size: 18px;
}

.texto-bold {
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;

}

.texto-rojo {
  background-color: #d7332a;
  color: white; /* Color de texto blanco */
  padding: 5px 10px; /* Espaciado interno */
  border-radius: 4px; /* Bordes redondeados */
}

.textMobile{
    font-size: 26px !important;
  }

}

/* Estilos para pantallas más pequeñas (por ejemplo, dispositivos móviles) */
@media (max-width: 767px) {

  .textMobile{
    font-size: 16px;
  }

  .imgMobile{
    width: 50% !important;
  }

  .contimg {
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: center;
  text-align: center;
}
  .imagens {
    width: 80%; /* Porcentaje de ancho para dispositivos móviles */

  }
  .contimg2 {
    display: flex;
    width: 100%;
    position: relative;
  }

  .imagens2 {
    width: 100%;
  }

  .curadradoRojo {
    background-color: #d7332a;
    padding: 10px;
  }

  .texto-derecha {
    position: absolute;
    top: 50%;
    right: 5%;
    color: white;
    transform: translateY(-50%);
    text-align: center;
    font-size: 15px;
    padding: 10px;
  }

  .texto-derecha label {
    font-weight: bold;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-derecha br {
    margin: 0;
    padding: 0;
  }

  .masFont {
    font-size: 20px;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-center {
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 1%;
  }

  .texto-white {
    color: #FFFFFF;
    font-family: 'Gotham', sans-serif;
    font-weight: lighter;
    font-size: 18px;
  }

  .texto-bold {
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }

  .texto-rojo {
    background-color: #d7332a;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
  }
}
</style>